<script setup lang="ts">
import { ref, watch, onMounted, onUnmounted } from 'vue';
import { storeToRefs } from 'pinia';
import { useLoadingStore } from '../store/Loading';
import { useI18n } from 'vue-i18n';
import { getSidebarOffset } from '../helpers/SidebarOffset';

const loadingStore = useLoadingStore();
const { isLoading } = storeToRefs(loadingStore);
const { t } = useI18n();

// Medido a cada exibição: --sidebar-width só é calculado ao montar o CustomDialog e fica errado depois de recolher a barra
const contentOffset = ref(0);
const updateContentOffset = () => {
    contentOffset.value = getSidebarOffset();
};

watch(isLoading, (loading) => {
    if (loading) updateContentOffset();
});

onMounted(() => window.addEventListener('resize', updateContentOffset));
onUnmounted(() => window.removeEventListener('resize', updateContentOffset));
</script>

<template>
    <!-- Modal Loading Overlay com Transição -->
    <Transition
        enter-active-class="transition-opacity duration-200 ease-out"
        enter-from-class="opacity-0"
        enter-to-class="opacity-100"
        leave-active-class="transition-opacity duration-150 ease-in"
        leave-from-class="opacity-100"
        leave-to-class="opacity-0">
        <div v-if="isLoading" class="fixed inset-0 z-40 flex items-center justify-center pointer-events-none" :style="{ left: `${contentOffset}px` }">
            <!-- Backdrop -->
            <div class="fixed inset-0 bg-black bg-opacity-40 pointer-events-auto"></div>
            
            <!-- Spinner Content com Animação -->
            <Transition
                enter-active-class="transition-all duration-200 ease-out"
                enter-from-class="transform scale-90 opacity-0"
                enter-to-class="transform scale-100 opacity-100"
                leave-active-class="transition-all duration-150 ease-in"
                leave-from-class="transform scale-100 opacity-100"
                leave-to-class="transform scale-90 opacity-0">
                <div class="relative z-40 pointer-events-none">
                    <!-- Spinner animado -->
                    <div class="flex flex-col items-center justify-center gap-4">
                        <div class="relative">
                            <!-- Círculo exterior -->
                            <div class="w-16 h-16 border-4 border-blue-200 dark:border-blue-900 rounded-full"></div>
                            <!-- Círculo animado -->
                            <div class="absolute top-0 left-0 w-16 h-16 border-4 border-blue-600 dark:border-blue-400 rounded-full border-t-transparent animate-spin"></div>
                        </div>
                        
                        <!-- Texto opcional (pode ser removido se preferir apenas o spinner) -->
                        <div class="text-white dark:text-gray-200 text-sm font-medium bg-gray-800 dark:bg-gray-700 px-4 py-2 rounded-lg shadow-lg">
                            {{ t('common.loading_message') }}
                        </div>
                    </div>
                </div>
            </Transition>
        </div>
    </Transition>
</template>
